/* MARVI OCEAN - homepage collection grid: rename the bottom button.

   WHY JAVASCRIPT AND NOT CSS
   A CSS ::after swap changes what you SEE but not what the DOM SAYS. Screen
   readers would still announce "View all designs". Tested; confirmed. This
   rewrites the actual text node, so the visual label and the accessible name
   change together.

   WHY NOT EDIT THE SECTION
   sections/collection-refined.liquid is 16KB holding the card grid, the
   killer-whale crossfade and the SEA IT reveal logic. Retyping it whole to
   change two words is a poor trade. This is one line, and it reverts by
   deleting one file. */
(function(){
  'use strict';
  function boot(){
    var link = document.querySelector('.csr-cta .btn-outline');
    if(!link) return;
    if(link.textContent.trim().toUpperCase() !== 'VIEW ALL DESIGNS') return;
    link.textContent = 'SEA COLLECTION';
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
